<div class="amadeus-direct-style">
  <div class="business-content">
    <ng-container *ngIf="config$ | async as state">
      <ng-container *ngIf="inventory$ | async as inventorySt">
        <ng-container *ngIf="inventorySt.isLoading">
          <spinner fixed="true"></spinner>
        </ng-container>

        <ng-container *ngIf="!inventorySt.isLoading">
          <div class="order-table_container">
            <table class="single-order-table inventory-table">
              <thead>
                <tr>
                  <td i18n="@@inventory-page.accountInventoryName">Name</td>

                  <ng-container *ngIf="state.config.display_quantity">
                    <td class="qnt-cell" i18n="@@inventory-page.accountOrdersDetailsQuantity">Quantity</td>
                  </ng-container>

                  <td i18n="@@inventory-page.accountInventoryActivationDate">Activation date</td>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let item of inventorySt.inventoryItems">
                  <tr>
                    <td>
                      <div>
                        <div class="product-image" [style.backgroundImage]="'url(' + item.image + ')'"></div>
                        <div class="product-title">
                          <ng-container *ngIf="item.sku !== ''; else noLink">
                            <a href="" [routerLink]="['/store', item.sku]">
                              {{ item.name }}
                            </a>
                          </ng-container>

                          <ng-template #noLink>
                            {{ item.name }}
                          </ng-template>
                        </div>
                      </div>
                    </td>

                    <ng-container *ngIf="state.config.display_quantity">
                      <td class="qnt-cell">{{ item.quantity | number }}</td>
                    </ng-container>

                    <td *ngIf="item.install_date !== null">
                      {{ item.install_date }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
